import { PARTY_MAX } from '@/lib/referral/xref01Validation';

export type ReferrerIdentity = { name: string | null; title: string | null };

export type ReferrerFieldIssue = 'missing' | 'too-long' | null;

/**
 * XREF01/XREF02/XREF06 Referrer: PersonName and PersonTitle are both sent.
 * XREF01.pdf: "PersonTitle skal medsendes. Er titel på henviser." (an..35).
 */
export function referrerNameIssue(name: string | null | undefined): ReferrerFieldIssue {
  const value = name ?? '';
  if (value.trim().length === 0) return 'missing';
  if (value.length > PARTY_MAX.referrerName) return 'too-long';
  return null;
}

export function referrerTitleIssue(title: string | null | undefined): ReferrerFieldIssue {
  const value = title ?? '';
  if (value.trim().length === 0) return 'missing';
  if (value.length > PARTY_MAX.referrerTitle) return 'too-long';
  return null;
}

/** The Referrer block for the request, or null when name or title is missing. */
export function referrerForRequest(
  identity: ReferrerIdentity | undefined,
): { personName: string; personTitle: string } | null {
  const personName = identity?.name?.trim() ?? '';
  const personTitle = identity?.title?.trim() ?? '';
  if (!personName || !personTitle) return null;
  return { personName, personTitle };
}
